import React from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuthStore from "../../../stores/auth-store.js";
import { useLogout } from "../../../hooks/useAuth.js";

function DropdownProfile() {
  // Get user data and logout function from auth store
  const navigate = useNavigate();
  
  const user = useAuthStore((state) => state.user);
  const logout = useLogout();

  // Handle logout click
  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    navigate('/user/login', { replace: true });
  };

  // Default profile picture if user doesn't have one
  const profilePicture = user?.profilePicture || "/assets/img/user/user.png";

  // Display name - use first_name and last_name if available, otherwise username
  const displayName = user
    ? user.first_name && user.last_name
      ? `${user.first_name} ${user.last_name}`
      : user.username
    : "User";

  return (
    <div className="navbar-item navbar-user dropdown">
      <a
        href="#/"
        className="navbar-link dropdown-toggle d-flex align-items-center"
        data-bs-toggle="dropdown"
      >
        <img src={profilePicture} alt={displayName} />
        <span>
          <span className="d-none d-md-inline fw-bold">{displayName}</span>
          <b className="caret"></b>
        </span>
      </a>
      <div className="dropdown-menu dropdown-menu-end me-1">
        <a href="#/" onClick={handleLogout} className="dropdown-item">
          Log Out
        </a>
        <div className="dropdown-divider"></div>
      </div>
    </div>
  );
}

export default DropdownProfile;
